import React, { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './component/screens/Home';
import Header from './component/HeaderFooterr/Header';
import Footer from './component/HeaderFooterr/Footer';
import SidebarContactus from './component/HomeComponent/SidebarContactus';
import { useSpring, animated } from '@react-spring/web';
import { Cursor } from './component/screens/Cursor';
import Services from './component/screens/Services';
import SocialMediaMarketing from './component/screens/SocialMediaMarketing';
import ScrollToTop from './component/ScrollComp/ScrollToTop';
import useScrollRestoration from './component/ScrollComp/useScrollRestoration';
import About from './component/screens/About';
import ContactUs from './component/screens/ContactUs';
import LogoDesign from './component/screens/LogoDesign';
import SeoService from './component/screens/SeoService';
import BrandingService from './component/screens/BrandingService';
import MobileApplication from './component/screens/MobileApplication';
import WebisteDesign from './component/screens/WebisteDesign';
import Portfolio from './component/screens/Portfolio';
import MagneticText from './component/screens/MagneticText';
import gsap from 'gsap';
function App() {
  const [isHovering, setIsHovering] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  const [animatedProps, setAnimatedProps] = useSpring(() => ({
    transform: `translate3d(0px, 0px, 0)`
  }));

  const handleMouseMove = (event) => {
    setCursorPosition({ x: event.clientX, y: event.clientY });
    setAnimatedProps({
      transform: `translate3d(${event.clientX}px, ${event.clientY}px, 0)`
    });
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  useScrollRestoration();

  useEffect(() => {
    // Split text into individual letters
    const wrapLetters = () => {
      const textElements = document.querySelectorAll(".text-box h2, .text-box p");
      textElements.forEach((el) => {
        const letters = el.textContent.split("");
        el.innerHTML = letters
          .map((letter) =>
            letter.trim() ? `<span class="letter">${letter}</span>` : "&nbsp;"
          )
          .join("");
      });
    };
    wrapLetters();

    // Custom cursor setup
    const cursor = document.querySelector(".custom-cursor");
    const cursorFollower = document.querySelector(".cursor-follower");

    const moveCursor = (e) => {
      gsap.to(cursor, { x: e.clientX, y: e.clientY, duration: 0.2 });
      gsap.to(cursorFollower, { x: e.clientX, y: e.clientY, duration: 0.4 });
    };

    document.addEventListener("mousemove", moveCursor);

    // Wave effect on letters
    const letters = document.querySelectorAll(".letter");
    const moveLetters = (e) => {
      letters.forEach((letter) => {
        const rect = letter.getBoundingClientRect();
        const dx = e.clientX - (rect.left + rect.width / 2);
        const dy = e.clientY - (rect.top + rect.height / 2);
        const dist = Math.sqrt(dx * dx + dy * dy);

        const maxDist = 150; // Maximum distance to trigger wave
        const intensity = Math.max(0, maxDist - dist) / maxDist;

        gsap.to(letter, {
          y: intensity * 10, // Vertical movement
          x: intensity * dx * 0.02, // Horizontal tilt
          rotation: intensity * 15, // Add a rotation effect
          duration: 0.3,
          ease: "power3.out",
        });
      });
    };

    document.addEventListener("mousemove", moveLetters);

    return () => {
      document.removeEventListener("mousemove", moveCursor);
      document.removeEventListener("mousemove", moveLetters);
    };
  }, []);

  return (
    
    <div onMouseMove={handleMouseMove} className="App">
      <Header />
      <ScrollToTop/>
      <SidebarContactus />
      <Routes>
        <Route path="/" element={<Home  />} />
        <Route path="/all-service" element={<Services  />} />
        <Route path="/logo-design" element={<LogoDesign  />} />
        <Route path="/seo-service" element={<SeoService  />} />
        <Route path="/branding-service" element={<BrandingService  />} />
        <Route path="/mobile-app-service" element={<MobileApplication  />} />
        <Route path="/website-design-service" element={<WebisteDesign  />} />
        <Route path="/smm-service" element={<SocialMediaMarketing  />} />
        <Route path="/about-us" element={<About  />} />
        <Route path="/portfolio" element={<Portfolio  />} />
        <Route path="/contact-us" element={<ContactUs  />} />
        <Route path="/magnetic-text" element={<MagneticText />} />
      </Routes>
      <Footer />
      {/* <div className="containerCursor">
        <animated.div style={animatedProps} className="wrapperCursor">
          <Cursor />
        </animated.div>
      </div> */}

      {/* {isHovering && (
        <div
          className="cursor-hover show"
          style={{ top: cursorPosition.y, left: cursorPosition.x }}
        >
          Open
        </div>
      )} */}
    </div>
  );
}

export default App;
